/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { imagePrettyUrl } from 'gatsby-core-theme/src/helpers/getters';
import Tnc from 'gatsby-core-theme/src/components/molecules/tnc';
import StarRating from 'gatsby-core-theme/src/components/molecules/star-rating/one-star';

import LazyImage from 'gatsby-core-theme/src/hooks/lazy-image';
import ToplistRow from '../../../../toplist/header/row-two/index';
import PrettyLink from '~atoms/pretty-link';
import OperatorCta from '~atoms/button/operator-cta';
import BonusBox from '~molecules/bonus-box/template-one';
import { TrackingKeys } from '~constants/tracking-api';
import ArrowIcon from '../../../../../../images/icons/arrow';

import styles from './template-three.module.scss';

const TemplateThree = ({
  page,
  moduleName = TrackingKeys?.HEADER.BONUS,
  buttonIcon = <ArrowIcon />,
}) => {
  let toplistModule = null;
  let BonusData = null;
  page?.sections?.header?.modules?.forEach((element) => {
    if (element?.name === 'bonus') {
      BonusData = element;
    } else if (element?.name === 'top_list') {
      toplistModule = element;
    }
  });
  const getBonus = (bonusModule) => {
    const operator = bonusModule.value;
    const itemName = operator?.name;
    // Note: Bonus Extra field
    const backgroundImage = operator?.extra_fields?.campaign_image;

    return (
      <div className={styles.bonus}>
        <PrettyLink
          operator={operator}
          pageTemplate={page.template}
          moduleName={moduleName}
          tracker={bonusModule.tracking_link_name}
          clickedElement="operator_logo"
          className={styles.bonusOperatorlogoContainer}
        >
          <LazyImage
            alt={operator?.name}
            loading="eager"
            width={168}
            height={168}
            src={imagePrettyUrl(operator?.logo?.filename, 168, 168)}
            className={styles.bonusOperatorlogo}
          />
        </PrettyLink>

        <div className={styles.bonusInfo}>
          <div className={styles.details}>
            <PrettyLink
              operator={operator}
              pageTemplate={page.template}
              moduleName={moduleName}
              tracker={bonusModule.tracking_link_name}
              clickedElement="operator_name"
              className={styles.bonusOperatorName}
            >
              {itemName}
            </PrettyLink>
            <StarRating numOfStars={5} rating={operator?.rating} showDecimal />
          </div>
          <BonusBox
            item={operator}
            tracker={bonusModule.tracking_link_name}
            onlinerTracker={bonusModule.type}
            moduleName={moduleName}
            pageTemplate={page.template}
          />
          <div className={styles.bonusCta}>
            <OperatorCta
              operator={operator}
              tracker={bonusModule.tracking_link_name}
              icon={buttonIcon}
              moduleName={moduleName}
              pageTemplate={page?.template}
              gtmClass="toplist-operator-cta-gtm"
            />
          </div>
          <div className={styles.tnc}>
            <Tnc isFixed operator={operator} />
          </div>
        </div>
        <LazyImage
          alt="Desktop Bonus BG"
          loading="eager"
          width={387}
          height={387}
          src={
            backgroundImage
              ? imagePrettyUrl(`${backgroundImage.filename}${backgroundImage.extension}`, 387, 500)
              : '/images/desktopBonusBg.png'
          }
          className={styles.bunusBGDesktop}
        />
      </div>
    );
  };

  const color = page?.extra_fields?.header_background_color;
  const bgImage = page?.extra_fields?.header_background_image;

  return (
    <div className={styles.container} style={color ? { background: color } : {}}>
      {bgImage && (
        <LazyImage
          alt="bgImage"
          loading="eager"
          width={1400}
          height={632}
          src={imagePrettyUrl(bgImage, 1400, 632)}
          className={styles.bgImage}
        />
      )}

      {BonusData && getBonus(BonusData)}
      {toplistModule && (
        <ul className={`${styles.toplistContainer || ''}`}>
          {toplistModule.items.map((item) => (
            <ToplistRow
              toplist={item}
              tracker={item.tracker}
              oneliner={item.one_liner}
              pageTemplate={page?.template}
              icon={buttonIcon}
            />
          ))}
        </ul>
      )}
    </div>
  );
};

TemplateThree.propTypes = {
  page: PropTypes.shape({
    title: PropTypes.string,
    template: PropTypes.string,
    sections: PropTypes.shape({
      header: PropTypes.shape({
        modules: PropTypes.arrayOf(PropTypes.shape({})),
      }),
    }),
    extra_fields: PropTypes.shape({
      header_background_color: PropTypes.string,
      header_background_image: PropTypes.string,
    }),
  }),
  moduleName: PropTypes.string,
  buttonIcon: PropTypes.element,
};

export default TemplateThree;
